import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/accounts',
    name: 'Accounts',
    component: () => import('../views/Accounts.vue')
  },
  // {
  //   path: '/rewards',
  //   name: 'Rewards',
  //   component: () => import('../views/Rewards.vue')
  // },
  {
    path: '/mundial',
    name: 'Mundial',
    component: () => import('../views/Mundial.vue')
  },
  {
    path: '/condiciones',
    name: 'Condiciones',
    component: () => import('../views/Condiciones.vue')
  },
  {
    path: '/who-we-are',
    name: 'WhoWeAre',
    component: () => import('../views/WhoWeAre.vue')
  },
  {
    path: '/calculator',
    name: 'Calculator',
    component: () => import('../views/Calculator.vue')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('../views/Support.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router
